import styles from './footer.module.scss';
const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      &#169; Exclusive Property of Compass India Food Services Pvt. Ltd.
    </footer>
  );
};

export default Footer;
